import { MenuItem } from '@core/models/entities/menu/menuItem';
import { IOMenuItem } from '@core/models/interfaceObjects/menu/IOMenuItem';
import { AuthService } from '@core/services/auth/auth.service';
import { MenuService } from '@core/services/menu/menu.service';
import { SystemService } from '@core/services/system/system.service';
import { TreeModule } from 'primeng/tree';

import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  QueryList,
  Renderer2,
  ViewChildren,
  inject
} from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-menu-tree',
  templateUrl: './menu-tree.component.html',
  styleUrls: ['./menu-tree.component.scss'],
  imports: [CommonModule, TreeModule]
})
export class MenuTreeComponent implements OnInit, OnChanges, AfterViewInit {
  @ViewChildren('menuItem') items!: QueryList<ElementRef>;

  @Input() data: MenuItem[] | null;
  voDataTree: IOMenuItem[] = [];
  currentItem: IOMenuItem | null;
  lastExpanded: IOMenuItem | null;
  readonly isLogout = 'logout';
  systemService = inject(SystemService);

  constructor(
    private router: Router,
    private menuService: MenuService,
    private authService: AuthService,
    private renderer: Renderer2
  ) {}

  ngOnInit() {
    this.listenCurrentMenuItem();
  }

  listenCurrentMenuItem() {
    this.menuService.getCurrentMenuItemObservable().subscribe(currentItem => {
      if (currentItem) {
        this.setMenuItem(currentItem);
        this.expandRecursiveTree(currentItem);
      }
    });
  }

  convertTreeData() {
    this.voDataTree = [];
    this.data?.forEach((menuItem: MenuItem) => {
      this.voDataTree.push(IOMenuItem.buildTree(menuItem, null));
    });

    if (!this.systemService.configuracao()?.exibeMenuAjuda) {
      this.voDataTree = this.voDataTree?.filter(
        item => item.label.toLowerCase() !== 'ajuda'
      );
    }
  }

  private expandRecursiveTree(item: IOMenuItem) {
    let current: IOMenuItem | null = item;
    let parent: IOMenuItem | null = null;
    while (!IOMenuItem.parentKeyAbsent(current)) {
      if (!current?.parentId) {
        break;
      }
      parent = IOMenuItem.searchItem(this.voDataTree, current?.parentId);

      if (parent && parent.children.length > 0) {
        parent.expanded = true;
      }

      current = parent;
    }
  }

  desmarcarItem(index: number) {
    this.items.forEach((item, i) => {
      if (item.nativeElement.id === index) {
        this.renderer.removeStyle(item.nativeElement.children[0], 'color');
        this.renderer.removeStyle(item.nativeElement.children[1], 'color');

        if (item.nativeElement.children > 2) {
          this.renderer.removeStyle(item.nativeElement.children[2], 'color');
        }
      }
    });
  }

  marcarItem(index: number) {
    this.items.forEach((item, i) => {
      if (item.nativeElement.id === index) {
        this.renderer.setStyle(
          item.nativeElement,
          'color',
          this.systemService.configuracao().corPredominante
        );
        /* this.renderer.setStyle(
           item.nativeElement.children[0],
           'color',
           this.systemService.configuracao().corPredominante
         );*/
      }
    });
  }

  expandItem(item: IOMenuItem) {
    if (this.lastExpanded && this.lastExpanded !== item && item.root) {
      this.lastExpanded.expanded = false;
    }

    if (item.root) {
      this.lastExpanded = item;
    }

    item.expanded = !item.expanded;
  }

  setMenuItem(currentItem: IOMenuItem) {
    this.marcarItem(currentItem.id);
    if (currentItem.children.length > 0) {
      return;
    }
    const previous = this.currentItem;
    const isEquals = previous && previous === currentItem;

    if (!isEquals && previous) {
      this.unmarkActiveItem(previous);
      this.desmarcarItem(previous.id);
      previous.actived = false;
      previous.expanded = false;
    }

    if (currentItem?.children.length > 0) {
      this.expandItem(currentItem);
    }

    if (currentItem?.children.length === 0) {
      currentItem.actived = true;
      this.markActiveItem(currentItem);
      this.marcarItem(currentItem.id);
      this.menuService.setCurrentMenuItem(currentItem);
    }

    this.currentItem = currentItem;
    if (currentItem.url === this.isLogout) {
      this.authService.logout().subscribe();
    } else if (currentItem.url.includes('http')) {
      window.open(currentItem.url, '_blank');
    } else {
      this.router.navigate([currentItem.url]);
    }
  }

  markActiveItem(currentItem: IOMenuItem) {
    let found = IOMenuItem.searchItem(this.voDataTree, currentItem.id);
    if (found) {
      found.actived = true;
    }
  }

  unmarkActiveItem(item: IOMenuItem) {
    let found = IOMenuItem.searchItem(this.voDataTree, item.id);
    if (found) {
      found.actived = false;
    }
  }

  ngOnChanges() {
    if (this.data) {
      this.convertTreeData();
    }
  }

  ngAfterViewInit() {
    this.items.forEach(item => {
      this.renderer.listen(item.nativeElement, 'mouseenter', () => {
        this.renderer.setStyle(
          item.nativeElement.children[0],
          'color',
          this.systemService.configuracao().corPredominante
        );
        this.renderer.setStyle(
          item.nativeElement.children[1],
          'color',
          this.systemService.configuracao().corPredominante
        );

        if (item.nativeElement.children > 1) {
          this.renderer.setStyle(
            item.nativeElement.children[2],
            'color',
            this.systemService.configuracao().corPredominante
          );
        }
      });

      this.renderer.listen(item.nativeElement, 'mouseleave', () => {
        this.renderer.removeStyle(item.nativeElement.children[1], 'color');
        this.renderer.removeStyle(item.nativeElement.children[0], 'color');

        if (item.nativeElement.children > 1) {
          this.renderer.removeStyle(item.nativeElement.children[2], 'color');
        }
      });
    });
  }
}
